import { render, staticRenderFns } from "./QuickAcessItem.vue?vue&type=template&id=5063705e&scoped=true&lang=pug"
import script from "./QuickAcessItem.vue?vue&type=script&lang=js"
export * from "./QuickAcessItem.vue?vue&type=script&lang=js"
import style0 from "./QuickAcessItem.vue?vue&type=style&index=0&id=5063705e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5063705e",
  null
  
)

export default component.exports